import { render } from "./ServiceSection.vue?vue&type=template&id=91ea6c80&scoped=true"
import script from "./ServiceSection.vue?vue&type=script&lang=js"
export * from "./ServiceSection.vue?vue&type=script&lang=js"

import "./ServiceSection.vue?vue&type=style&index=0&id=91ea6c80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ea6c80"]])

export default __exports__